<template>
  <div>
    <el-dialog
      v-if="evaluation.setting"
      append-to-body
      :close-on-click-modal="false"
      title="Добавление коллег"
      :visible.sync="show"
      width="70%"
      destroy-on-close
    >
      <el-row>
        <el-row style="margin-bottom: 20px">
          <el-col :span="6">
            <search-input
              style="width: 100%"
              v-model="search"
              prefix-icon="el-icon-search"
              placeholder="Поиск по ФИО"
              size="small"
              clearable
              @change="searchChanged"
            >
            </search-input>
          </el-col>
        </el-row>
        <el-form
          size="small"
          label-position="top"
        >
          <el-form-item :label="'Выберите коллег (максимум: ' + evaluation.setting.colleague_max + ')'">
            <el-table
              border
              v-loading="loading"
              ref="selectColleaguesTable"
              size="mini"
              :data="colleagues"
              :row-key="(row) => row.id"
            >
              <el-table-column type="selection" reserve-selection width="55"></el-table-column>
              <el-table-column prop="full_name" label="ФИО"></el-table-column>
              <el-table-column prop="email" label="Email"></el-table-column>
              <el-table-column prop="position" label="Должность"></el-table-column>
              <el-table-column prop="subdivision" label="Подразделение"></el-table-column>
              <el-table-column prop="company" label="Компания"></el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <paginator
          :paginator.sync="paginator"
          @page-changed="searchColleagues"
        ></paginator>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">Отмена</el-button>
        <el-button
          :disabled="$refs.selectColleaguesTable && !$refs.selectColleaguesTable.selection.length"
          :loading="loading"
          type="primary"
          @click="addSelectedColleagues"
          size="small"
          icon="fas fa-plus"
        >
          Добавить отмеченных
        </el-button>
      </div>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>
import {off, on} from "element-ui/src/utils/dom";
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";

export default {
  name: "add-eval-colleagues-dialog",
  mixins: [paginator],
  components: {SearchInput, Paginator},
  data() {
    return {
      loading: false,
      show: false,
      search: null,
      colleagues: [],
    }
  },
  props: {
    all: {
      type: Boolean,
      default: false,
    },
    user_id: {
      type: Number,
      default: 0,
    },
    evaluation: {
      type: Object,
      default: {},
    },
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.open);
    }
  },
  methods: {
    open() {
      this.search = null;
      this.paginator.page = 1;
      this.paginator.perPage = 10;
      this.show = true;
      this.colleagues = [];

      this.searchColleagues();
    },
    searchChanged() {
      this.paginator.page = 1;
      this.searchColleagues();
    },
    searchColleagues() {
      this.loading = true;

      this.$api.evaluation.myEvaluationAllColleaguesSearch({
        evaluation_id: this.evaluation.id,
        all: this.all,
        user_id: this.user_id,
        search: this.search,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.colleagues = data.colleagues;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    addSelectedColleagues() {
      let newColleagueIds = [];
      this.$refs.selectColleaguesTable.selection.forEach(colleague => {
        newColleagueIds.push(colleague.id);
      })

      if (newColleagueIds) {
        this.$api.evaluation.myEvaluationColleagueCreate({
          colleague_ids: newColleagueIds,
          evaluation_id: this.evaluation.id,
          user_id: this.user_id,
        })
          .then(data => {
            if (data.status === 'error') {
              this.$notify.error({
                title: 'Ошибка',
                message: data.message
              });
            } else {
              this.show = false;

              this.$notify.success({
                title: 'Сохранено',
                message: 'Коллеги успешно добавлены'
              });
              this.$emit('load-colleagues');
              this.$emit('refresh-evaluatee');
              this.$emit('load-evaluators');
            }
          })
          .finally(()=>{
            this.loading = false;
          })
      }
    },
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.open);
    }
  }
}
</script>

<style scoped>

</style>